export default __webpack_public_path__ + "static/media/2.577d47a8.png";